export default "__VITE_ASSET__d155ed74__"